import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import type IntlService from "ember-intl/services/intl";
import tWithDefault from "parog-web/utils/t-with-default";

interface Signature {
  Args: { Positional: [key: string, defaultOption: string] };
  Return: string;
}

export default class TWithDefault extends Helper<Signature> {
  @service
  declare intl: IntlService;

  compute([key, defaultOption]: Signature["Args"]["Positional"]) {
    return tWithDefault(this.intl, key, defaultOption);
  }
}
